import '../../base/outline-container/outline-container';
import { CSSResultGroup, html, nothing, TemplateResult } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import componentStyles from './ghs-jumbo-cta.css.lit';
import '../ghs-icon/ghs-icon';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { SlotController } from '../../controllers/slot-controller';
import { ifDefined } from 'lit/directives/if-defined.js';
export type CardAlignmentVariant = 'left-align' | 'right-align';
export type ComponentVariant = 'one-column' | 'two-column';

/**
 * The Jumbo CTA component
 *
 * @element ghs-jumbo-cta
 * @todo make this take its image in a slot for Bellin so the image can be responsive.
 */
@customElement('ghs-jumbo-cta')
export class GhsJumboCta extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  slots = new SlotController(this, true);

  /**
   * The alignment style variant to use.
   * @param alignment
   * @default 'left-align'
   */
  @property({ type: String, reflect: true })
  alignment: CardAlignmentVariant = 'left-align';

  /**
   * The BH component variant to use.
   * @param variant
   * @default 'one-column'
   */
  @property({ type: String, reflect: true })
  variant: ComponentVariant = 'one-column';

  /**
   * The Background image URL.
   */
  @property({ attribute: 'bg-image-url' })
  bgImageUrl: String;

  @state() hasImgSlot: boolean;

  firstUpdated(): void {
    super.firstUpdated();
    this.hasImgSlot = this.querySelector('[slot="image"]') !== null;
  }

  renderImage(): TemplateResult {
    return html`
      <div class="jumbo-image">
        <div class="image-wrapper">
          <slot name="image"></slot>
        </div>
        <div class="inner-border"></div>
      </div>
    `;
  }

  renderCta(): TemplateResult {
    return html`
      <div class="jumbo-button">
        <slot name="jumbo-button"></slot>
      </div>
    `;
  }

  render(): TemplateResult {
    return html`
      <div
        class="jumbo"
        style="${ifDefined(
          this.site !== 'BH'
            ? `background-image: url(${this.bgImageUrl});`
            : undefined
        )}"
      >
        <outline-container
          class="jumbo-content-wrapper ${this.site === 'BH'
            ? this.variant
            : this.alignment}"
          x-padding
        >
          <div class="jumbo-content-section">
            ${this.hasImgSlot ? this.renderImage() : nothing}
            <div class="jumbo-headline">
              <slot name="jumbo-headline"></slot>
            </div>
            <div class="jumbo-body-text">
              <slot name="jumbo-body-text"></slot>
              ${this.site === 'BH' ? this.renderCta() : nothing}
            </div>
            ${this.site !== 'BH' ? this.renderCta() : nothing}
          </div>
        </outline-container>
      </div>
    `;
  }
}
